<p *ngIf="loading" style="text-align: center;">Load order..</p>
<p *ngIf="!loading" style="text-align: center;">Payment order: {{orderId}}</p>
